import React, { useEffect } from 'react'

type AutoEndSessionProps = {
    openWelcomeMessage: () => void,
    setShowWelcomeMessage:(type: boolean) => void,
    autoEndBotSession: () => void,
    showWelcomeMessage: boolean
}

const AutoEndSession = ({openWelcomeMessage, setShowWelcomeMessage, autoEndBotSession, showWelcomeMessage}: AutoEndSessionProps) => {

    const restartChat = () => {
        setShowWelcomeMessage(false);
    }

    useEffect(() => {
        if(!showWelcomeMessage){
            openWelcomeMessage();
            autoEndBotSession();
        }
    }, [showWelcomeMessage])
    

   
    return (
        <div className="widget__overlay--endsession" id="endSession">
            <div className="warning-text">
                <div>Your chat session has ended.</div>  
            </div>
            <div className="action-buttons" style={{ justifyContent: 'center' }}>
                    <input type="button" value="Restart Chat" className='form-button secondary' id="start-again-button" onClick={() => restartChat()}/>
            </div>
        </div>
    )
}

export default AutoEndSession